module.exports = __webpack_public_path__ + "img/logo.3f58b3f5.png";